import { render } from "./CreateReferrer.vue?vue&type=template&id=6e050d9e&scoped=true"
import script from "./CreateReferrer.vue?vue&type=script&lang=js"
export * from "./CreateReferrer.vue?vue&type=script&lang=js"

import "./CreateReferrer.vue?vue&type=style&index=0&id=6e050d9e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e050d9e"]])

export default __exports__